import { useParams } from "@tanstack/react-router";
import { CategoryDetail } from "@/components/admin/CategoryDetail";

export function SettingsCategoryDetailPage() {
  const { categoryId } = useParams({ strict: false }) as { categoryId: string };
  return <CategoryDetail categoryId={categoryId} />;
}
